import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DocentesDependenciaUaaDto } from '../dto/docentes-dependencia-uaa-dto';
import { CorreoParDto } from '../dto/correo-par-dto';

@Injectable({
  providedIn: 'root'
})
export class DocenteService {

  url = `${environment.host}/api/docentes`;

  constructor(
    private http: HttpClient
  ) { }

  obtenerDocentes(): Observable<DocentesDependenciaUaaDto[]> {
    return this.http.get<DocentesDependenciaUaaDto[]>(`${this.url}/docentes-por-dependencia/0`);
  }

  obtenerListaDocentesNombre(nombre: string): Observable<DocentesDependenciaUaaDto[]> {
    return this.http.get<DocentesDependenciaUaaDto[]>(`${this.url}/docentesParNombre/0/${nombre}`);
  }

  obtenerDocenteIdentificacion(identificacion: string, periodo: number): Observable<DocentesDependenciaUaaDto[]> {
    return this.http.get<DocentesDependenciaUaaDto[]>(`${this.url}/docenteParIdentificacion/0/${identificacion}/${periodo}`);
  }

  obtenerParIdentificacion(identificacion: string): Observable<DocentesDependenciaUaaDto[]> {
    return this.http.get<DocentesDependenciaUaaDto[]>(`${this.url}/docenteIdentificacion/${identificacion}`);
  }

  emailEvaluacion(email: CorreoParDto): Observable<CorreoParDto> {
    return this.http.put<CorreoParDto>(`${this.url}/email/par`, email);
  }
}
